import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from 'ats-ui-lib';

const decimalPlaces = 2;

@Pipe({
  name: 'fileSize',
  standalone: false,
})
export class FileSizePipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(numberOfBytes: number | undefined | null): string {
    if (numberOfBytes == null) {
      throw new Error('This pipe expects a number to work');
    }
    if (numberOfBytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(numberOfBytes) / Math.log(k));
    const size = numberOfBytes / k ** i;
    const sizeString = size.toLocaleString(this.languageService.language, {
      maximumFractionDigits: decimalPlaces,
    });
    return `${sizeString} ${sizes[i]}`;
  }
}
